import { EventEmitter, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EndPointApi } from '@helpers/endpointapi';
import { BarGraph, ExhaustGraph, GaugeGraph, Graph } from 'icreate/common/models/graphs';

@Injectable({ providedIn: 'root' })
export class GraphsService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    graphsLoadingEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

    graphList$: EventEmitter<Graph[]> = new EventEmitter<Graph[]>();

    graphList: Graph[];

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getAll(vesselId) {
        this.graphList = await lastValueFrom<Graph[]>(this.http.get<Graph[]>(`${this.domain}/api/graphs/${vesselId}`));

        return this.graphList;
    }

    getGraphList() {
        return this.graphList;
    }

    updateGraphList(updatedList) {
        this.graphList = updatedList;
        this.graphList$.emit(updatedList);
    }

    async getGraphById(graphId, graphType) {
        const params = { graphType };
        return await lastValueFrom<any>(this.http.get<any>(`${this.domain}/api/graph/${graphId}`, { params }));
    }

    async createGraph(graph) {
        return lastValueFrom(this.http.post(`${this.domain}/api/graph`, graph, { headers: this.headers }));
    }

    async deleteGraph(graphId) {
        return lastValueFrom(this.http.delete(`${this.domain}/api/graph/${graphId}`));
    }

    async updateGraph(title, graphId) {
        return await lastValueFrom(this.http.put(`${this.domain}/api/graph/${graphId}`, { title }));
    }

    async reorderGraphs(vesselId: string, orderedIds: string[]) {
        return lastValueFrom(
            this.http.put(`${this.domain}/api/graphs/reorder`, { vesselId, orderedIds }, { headers: this.headers })
        );
    }

    async updateExhaustGraph(graph: ExhaustGraph) {
        return lastValueFrom(this.http.put(`${this.domain}/api/exhaust-graph`, graph));
    }

    async updateGaugeGraph(graph: GaugeGraph) {
        return lastValueFrom(this.http.put(`${this.domain}/api/gauge-graph`, graph));
    }

    async updateBarGraph(graph: BarGraph) {
        return lastValueFrom(this.http.put(`${this.domain}/api/bar-graph`, graph));
    }

    showLoadingSpinner(showSpinner) {
        this.graphsLoadingEmitter.emit(showSpinner);
    }
}
